import axiosInstance from '@/lib/axios';
import {
  LoginRequestSecretStringPayload,
  LoginRequestSecretStringResponse,
  LoginValidateHashedSecretPayload,
  LoginValidateHashedSecretResponse,
} from './types';

export async function loginRequestSecretString(
  payload: LoginRequestSecretStringPayload,
) {
  const { data } = await axiosInstance.post<LoginRequestSecretStringResponse>(
    `auth/login/requestSecret`,
    payload,
  );
  return data;
}

export async function loginValidateHashedSecret(
  payload: LoginValidateHashedSecretPayload,
) {
  const { data } = await axiosInstance.post<LoginValidateHashedSecretResponse>(
    `auth/login/validateSecret`,
    payload,
  );
  return data;
}
